export var cleanTermForURL = (term) => {
  return term
    .trim()
    .split('#')
    .join('%23')
    .split('?')
    .join('%3F')
    .split('/')
    .join('-')
    .split(String.fromCharCode(8482))
    .join('')
    .split(String.fromCharCode(233))
    .join('e')
    .split(String.fromCharCode(244))
    .join('o')
    .split(String.fromCharCode(207))
    .join('i')
    .split(String.fromCharCode(206))
    .join('i')
    .split(String.fromCharCode(201))
    .join('e')
    .split(String.fromCharCode(200))
    .join('e')
    .split(String.fromCharCode(234))
    .join('e')
    .split(String.fromCharCode(180))
    .join("'")
    .split(String.fromCharCode(232))
    .join('e')
    .split(String.fromCharCode(216))
    .join('Ø')
    .split(String.fromCharCode(248))
    .join('ø')
    .split(' ')
    .join('+');
};
